<kodit-dropdown
  [options]="items"
  ctrlTooltip="Izaberite organizaciju"
  ctrlTooltipPosition="top"
  (optionChanged)="handleItemChange($event)"
></kodit-dropdown>
